module.exports = __webpack_public_path__ + "media/images/ibjjf/academy_registration_informations/rules_draw-293b3d10035ce3b8020eb7e4fd4bbc95.svg";